import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ClockOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ClockOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M21 12a9 9 0 1 0-9 9v2C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11v-2a9 9 0 0 0 9-9Z" />
          <path d="M13 6v5.586l3.207 3.207-1.414 1.414L11 12.414V6h2Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ClockOutlined;